import { connect } from 'react-redux'
import React, { useState, useEffect } from 'react'
import { BackgroundSignUp } from '../newsignup/BackgroundSignUp'
import EmailPasswordForm from './EmailPasswordForm'
import PasskeyLoginButton from '../PasskeyLoginButton'
import { Logo } from './Logo'
import { Progress } from './Progress'
import { LOGIN, RESTORE_PASSWORD, FETCH_SESSION } from '../../../_common/redux/auth/actions'
import _get from 'lodash/get'
import queryString from 'query-string'
import { isTwoFactorRequiredError } from '../../../_common/redux/auth/isTwoFactorRequiredError'
import { NotificationError } from './NotificationError'
import { Trademark } from '../newsignup/Trademark'
import { Titles } from './Titles'

const NewSignInPageRedux = ({ location: { state }, LOGIN, history, RESTORE_PASSWORD, FETCH_SESSION }) => {
  useEffect(() => {
    localStorage.removeItem('createAccountState')
  }, [])
  const handleSubmit = async formData => {
    const { isResettingPassword, ...form } = formData

    if (isResettingPassword) {
      try {
        const res = await RESTORE_PASSWORD(form.email)
        return { ...res, disableRedirect: true }
      } catch (e) {
        const error = _get(e, 'response.data.message')

        if (error) {
          setError(error)
        }
        throw e
      }
    }

    try {
      const res = await LOGIN({
        attributes: { ...form, username: form.email, newSignupFlow: true },
      })
      const hasDashboardAccess = _get(res, 'data.hasDashboardAccess')
      if (hasDashboardAccess !== undefined) {
        isProd() && fbq('trackCustom', 'CustomerLoggedInSuccesfully', { email: form.email })
        localStorage.setItem(
          'createAccountState',
          JSON.stringify({
            email: res?.data?.email,
            password: '',
            lastName: res?.data?.lastName,
            firstName: res?.data?.firstName,
            confirmPassword: '',
            best_describe: '2',
            skipCreateAccount: true,
            goBack: true,
          }),
        )
        history.push('/welcome/create-account', {
          skipCreateAccount: true,
          password: form.password,
          email: form.email,
          firstName: _get(res, 'data.firstName'),
          lastName: _get(res, 'data.lastName'),
          confirmPassword: form.password,
        })
        history.push('/welcome/create-brand', {
          email: res?.data?.email,
          password: '',
          lastName: res?.data?.lastName,
          firstName: res?.data?.firstName,
          confirmPassword: '',
          best_describe: '2',
          skipCreateAccount: true,
          referral: state.referral,
          user_id: res?.data?.id,
        })
        throw new Error('Can update his account and create a brand.')
      }
      return res
    } catch (e) {
      if (isTwoFactorRequiredError(e)) {
        history.replace({ pathname: '/two-factor', search: queryString.stringify({ next: '/' }) })
        return
      }
      const error = _get(e, 'response.data.message')
      if (error) {
        setError(error)
      }
      throw e
    }
  }
  const [error, setError] = useState('')
  return (
    <div className="absolute-container new-sign-in">
      <Logo />
      <Progress width={0} />
      <Titles text="Sign in as an event organizer" />
      {error ? <NotificationError error={error} setError={setError} /> : null}
      <BackgroundSignUp>
        <EmailPasswordForm onSubmit={handleSubmit} {...state} setError={setError} />
        <PasskeyLoginButton
          className="submit-button-login"
          onSuccess={async () => {
            try {
              await FETCH_SESSION({
                hideError: true,
                noAppcues: true,
                throwOnError: true,
              })
            } catch (e) {
              if (isTwoFactorRequiredError(e)) {
                history.replace({ pathname: '/two-factor', search: queryString.stringify({ next: '/' }) })
                return true
              }
              throw e
            }
            // Dashboard passkey complete already requires organizer access.
            history.push('/')
            return true
          }}
          onError={msg => setError(msg)}
        />
      </BackgroundSignUp>
      <Trademark />
    </div>
  )
}

const NewSignInPage = connect(null, { LOGIN, RESTORE_PASSWORD, FETCH_SESSION })(NewSignInPageRedux)

export { NewSignInPage }
